import React from "react";

import imageLeft from "../../assets/footer/logoCleo.png";
import styles from "./FooterLeft.module.css";

const FooterLeft = () => {
  return (
    <div className={styles.footerLeft}>
      <img src={imageLeft} alt="Cleo Childminding" />
      <div>
        <p className={styles.brand}>Cleo Childminding</p>
        <p className={styles.text}>
          A warm, safe and stimulating childminding setting in Bo'ness.
        </p>
      </div>
    </div>
  );
};

export default FooterLeft;
